import { ComponentType } from 'react';
import marketingNeil from 'assets/marketing-neil.jpg';
import onboardingLarry from 'assets/onboarding-larry.jpg';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { OnboardingRoutes } from '../../../routes/onboarding-routes';

export type OnboardingRouteDefinition = {
  id: OnboardingSignupStep;
  Component: ComponentType;
  path: string;
};

export const SIDEBAR_ENTRIES = [
  {
    routePath: OnboardingRoutes.connectPages.getLink(),
    img: marketingNeil,
    text: 'CONNECT WITH YOUR FUTURE CUSTOMERS...',
    subtext: `
        For some reason, not very many marketers are taking advantage of Messenger marketing,
        even though it’s the hottest opportunity in digital marketing today.
    `,
    authorName: 'Neil Patel',
    authorTitle: 'Forbes Top 10 Marketer ',
  },
  {
    routePath: OnboardingRoutes.userInfo.getLink(),
    img: onboardingLarry,
    text: '...ON THE MESSAGING PLATFORMS THEY ALREADY USE',
    subtext: `
        Marketers can use MobileMonkey to connect with customers on the most popular mobile chat
        application in the U.S., Facebook Messenger, used by over a billion people every day.
    `,
    authorName: 'Larry Kim',
    authorTitle: 'CEO & Co-founder, MobileMonkey',
  },
];

export const ONBOARDING_ROUTES: OnboardingRouteDefinition[] = [
  {
    id: OnboardingSignupStep.CONNECT_PAGE,
    path: OnboardingRoutes.connectPages.getLink(),
    Component: OnboardingRoutes.connectPages.component,
  },
  {
    id: OnboardingSignupStep.USER_INFO,
    path: OnboardingRoutes.userInfo.getLink(),
    Component: OnboardingRoutes.userInfo.component,
  },
];
